"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CarCatologIcons = void 0;
var react_router_dom_1 = require("react-router-dom");
var carCatologIcons_module_scss_1 = __importDefault(require("./carCatologIcons.module.scss"));
var react_1 = __importDefault(require("react"));
var getCarCatalogImg_1 = require("../../helpers/catalog/getCarCatalogImg");
var CarCatologIcons = function (props) {
    var brand = props.brand, models_count = props.models_count;
    return (react_1.default.createElement(react_router_dom_1.Link, { title: brand, to: "/catalog/".concat(brand), className: carCatologIcons_module_scss_1.default.top_brands_item },
        react_1.default.createElement("div", { className: carCatologIcons_module_scss_1.default.top_brands_img },
            react_1.default.createElement("img", { src: (0, getCarCatalogImg_1.getCarCatalogImg)(brand), alt: brand, title: brand })),
        react_1.default.createElement("div", { className: carCatologIcons_module_scss_1.default.top_brands_title }, brand),
        react_1.default.createElement("span", { className: carCatologIcons_module_scss_1.default.top_brands_countcars }, models_count)));
};
exports.CarCatologIcons = CarCatologIcons;
